import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

export const bootstrap = new BootstrapBrowserBuilder('ra-landlord-web-ssr', Number(__BUILD_NUMBER__))
  .withLoggerOptions({ logPath: '/log', level: 'info' })
  .withDatadogPlugin('e3bd95b1-50cd-4ad0-bcc7-af0ffc600d69', 'pub1852719d860411d967ab763b20d36fe4')
  .withOnRegister(analytics.initialize)
  .build();
